export const locale = {
    lang: 'en',
    data: {
        'FIELDS': {
            'ProjectInfo': 'Project requisition information',
        },
    }
};